
{
  "fr": {
    "configuratorAddToCartUi": {
      "steps": {
        "export": "Export de votre personnalisation",
        "upload": {
          "label": "Envoi de votre personnalisation",
          "progress": "({progress}%)"
        },
        "addToCart": "Ajout au panier"
      },
      "error": "Une erreur est survenue, merci de ressayer.\n\nSi le problème persiste, merci de nous contacter via le formulaire prévu à cet effet."
    }
  }
}
